"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/gift-card-order-reversal-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Fgift-card-order-reversal-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.giftCardOrderReversalTypeToJSON = exports.giftCardOrderReversalTypeFromJSON = exports.GiftCardOrderReversalContext = exports.GiftCardOrderReversalType = void 0;
const protobufPackage = 'com.step.common.proto';
var GiftCardOrderReversalType;
(function (GiftCardOrderReversalType) {
    GiftCardOrderReversalType["INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE"] = "INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE";
    /**
     * PROVIDER_ERROR - Provider failed to process the order.
     */
    GiftCardOrderReversalType["PROVIDER_ERROR"] = "PROVIDER_ERROR";
    GiftCardOrderReversalType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GiftCardOrderReversalType || (exports.GiftCardOrderReversalType = GiftCardOrderReversalType = {}));
function createBaseGiftCardOrderReversalContext() {
    return { reversalType: GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE };
}
exports.GiftCardOrderReversalContext = {
    fromJSON(object) {
        const message = {
            reversalType: isSet(object.reversalType)
                ? giftCardOrderReversalTypeFromJSON(object.reversalType)
                : GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reversalType !== GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE) {
            obj.reversalType = giftCardOrderReversalTypeToJSON(message.reversalType);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardOrderReversalContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardOrderReversalContext();
        message.reversalType = object.reversalType ??
            GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE;
        return message;
    },
};
function giftCardOrderReversalTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE':
            return GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE;
        case 1:
        case 'PROVIDER_ERROR':
            return GiftCardOrderReversalType.PROVIDER_ERROR;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return GiftCardOrderReversalType.UNRECOGNIZED;
    }
}
exports.giftCardOrderReversalTypeFromJSON = giftCardOrderReversalTypeFromJSON;
function giftCardOrderReversalTypeToJSON(object) {
    switch (object) {
        case GiftCardOrderReversalType.INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE:
            return 'INVALID_GIFT_CARD_ORDER_REVERSAL_TYPE';
        case GiftCardOrderReversalType.PROVIDER_ERROR:
            return 'PROVIDER_ERROR';
        case GiftCardOrderReversalType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.giftCardOrderReversalTypeToJSON = giftCardOrderReversalTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=gift-card-order-reversal-context.js.map